
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/akupunktur",
      function () {
        return require("private-next-pages/akupunktur/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/akupunktur"])
      });
    }
  